import { useMemo } from 'react';

import { useCurrentWorkspaceId } from './useCurrentWorkspaceId';
import { useCurrentWorkspaces } from './useCurrentWorkspaces';

export const useCurrentWorkspace = () => {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const workspaces = useCurrentWorkspaces();

  return useMemo(
    () => workspaces.find((item) => item.id === currentWorkspaceId),
    [workspaces, currentWorkspaceId]
  );
};
